module.exports = __webpack_public_path__ + "img/kefu1.35211607.png";